import type { MetricType } from 'lumen/models/market-performance/data-item';
import {
  type ColumnSettings,
  parseColumnSettings,
} from 'lumen/utils/market-snapshots/column-settings';

/**
 * Reads and parses a stored preference. Missing or corrupt JSON goes through
 * `parse(null)`, so the parser decides the fallback (its defaults).
 */
export function readStored<T>(
  storage: { getItem: (key: string) => string | null },
  key: string,
  parse: (json: unknown) => T,
): T {
  try {
    return parse(JSON.parse(storage.getItem(key) ?? 'null'));
  } catch {
    return parse(null);
  }
}

/** Stored column settings validated against `ids` (see `parseColumnSettings`). */
export function readColumnSettings<T extends string>(
  storage: { getItem: (key: string) => string | null },
  key: string,
  ids: readonly T[],
  fixed?: MetricType,
): ColumnSettings<T> {
  return readStored(storage, key, (json) =>
    parseColumnSettings(json, ids, fixed),
  );
}
